// @flow

import React from 'react';
import glamorous from 'glamorous';
// this is an unusual one, taking a component from 'friends' in our base directory
// but for now, search bar uses a friends specific styling
// so we'll use FriendTextInput as our 'base' until such a time
// as it becomes a 'common' component within the system itself
import FriendTextInput from 'app/components/friends/common/FriendTextInput';

type Props = {
  condensed?: boolean,
  editMode?: boolean,
  onBeginSearch?: () => void,
  onClear?: () => void,
  onEndSearch?: () => void,
  onSearch: (searchTerm: string) => void,
  placeholder: string,
  scheme?: 'light' | 'dark',
  value?: string,
};

const defaultProps = {
  condensed: undefined,
  editMode: undefined,
  onBeginSearch: undefined,
  onClear: undefined,
  onEndSearch: undefined,
  scheme: undefined,
  value: '',
};

const Wrapper = glamorous.div(({ theme }) => ({
  fontSize: theme.fontSize.small,
}));

function FriendSearchBar({
  condensed,
  editMode,
  onBeginSearch,
  onClear,
  onEndSearch,
  onSearch,
  placeholder,
  scheme,
  value,
}: Props) {
  return (
    <Wrapper>
      <FriendTextInput
        condensed={condensed}
        editMode={editMode}
        onBlur={onEndSearch}
        onClear={onClear}
        onEscape={onClear}
        onFocus={onBeginSearch}
        onTextChange={onSearch}
        placeholder={placeholder}
        scheme={scheme}
        text={value}
      />
    </Wrapper>
  );
}

FriendSearchBar.defaultProps = defaultProps;

export default FriendSearchBar;
